import { Directive, ElementRef, effect, inject, input } from '@angular/core';

import { ColorCustomisation } from '../model/color-preset.model';

@Directive({
  standalone: true,
  selector: '[ttColorCustomisations]',
})
export class ColorCustomisationsDirective {
  public customisation = input.required<ColorCustomisation>();

  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);

  private readonly suffixes = ['fill', 'stroke', 'text'] as const;
  private readonly allKeys: (keyof ColorCustomisation)[] = ['action', 'start', 'decision', 'selection-behavior', 'container', 'link-label'];

  constructor() {
    effect(() => {
      const style = this.el.nativeElement.style;
      const customisation = this.customisation();

      for (const key of this.allKeys) {
        for (const suffix of this.suffixes) {
          style.removeProperty(`--tt-customisation-${key}-${suffix}`);
        }
      }

      if (!customisation) {
        return;
      }

      for (const [key, value] of Object.entries(customisation)) {
        if (value) {
          for (const suffix of this.suffixes) {
            style.setProperty(`--tt-customisation-${key}-${suffix}`, `var(--tt-color-preset-${value}-${suffix})`);
          }
        }
      }
    });
  }
}
